import {
  Box,
  Button,
  Flex,
  Heading,
  HStack,
  IconButton,
  Input,
  Text,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import {
  RiAddCircleLine,
  RiDeleteBin6Line,
  RiIndeterminateCircleLine,
} from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import MainModel from "../../../../components/Models/main-model";
import {
  adminModalBodyProps,
  adminModalContentProps,
  adminModalHeaderProps,
} from "../../../../components/Models/admin-modal-theme";
import { closeAddVideoFielsModel } from "../../../../modules/admin-modules/models/Actions";
import {
  addVideoFilesRequest,
  deleteVideoFilesRequest,
} from "../../../../modules/admin-modules/videos/Actions";

const filePickButtonSx = {
  position: "relative",
  flex: 1,
  minW: "160px",
  variant: "outline",
  borderRadius: "12px",
  borderColor: "#D6CEC0",
  color: "#7A1422",
  bg: "#FAF2EB",
  fontWeight: "700",
  minH: "44px",
  _hover: { bg: "white", borderColor: "#7A1422" },
  _focus: { outline: "none", boxShadow: "0 0 0 3px rgba(122, 20, 34, 0.18)" },
};

const uploadButtonProps = {
  bg: "#6A1E1E",
  color: "white",
  borderRadius: "lg",
  px: 6,
  fontWeight: "800",
  minH: "44px",
  _hover: { bg: "#4A0F1F" },
  boxShadow: "0 10px 24px rgba(106, 30, 30, 0.18)",
  _active: { bg: "#4A0F1F" },
};

const iconOutlineProps = {
  variant: "outline",
  borderColor: "#D6CEC0",
  color: "#7A1422",
  borderRadius: "full",
  size: "sm",
  _hover: {
    bg: "rgba(255,255,255,0.95)",
    borderColor: "#7A1422",
    color: "#6A1E1E",
  },
  _focus: { outline: "none", boxShadow: "0 0 0 3px rgba(122, 20, 34, 0.18)" },
};

const AddVideoFiels = ({ isAdd, data }) => {
  const [selected, setSelected] = useState([{ name: "upload file", file: "" }]);
  const [fieldsCount, setFieldsCount] = useState(1);
  const openVideo = useSelector((state) => state.model.isOpen10);
  const isLoading = useSelector((state) => state.videos.isLoading);
  const dispatch = useDispatch();

  const closeFunc = () => {
    dispatch(closeAddVideoFielsModel());
  };

  const header = (
    <Box>
      <Heading
        textAlign="center"
        fontSize="28px"
        fontWeight="800"
        color="#6A1E1E"
        fontFamily="'Amiri','Tajawal',sans-serif"
      >
        {isAdd ? "Add video files" : "Edit video files"}
      </Heading>
      <Text
        fontSize="xs"
        mt={1}
        color="rgba(74, 15, 31, 0.6)"
        textTransform="uppercase"
        letterSpacing="0.12em"
        fontWeight="700"
        textAlign="center"
      >
        Attach files to this video
      </Text>
    </Box>
  );

  const handelFiles = async (values, index) => {
    if (!values) return;
    const formData = new FormData();
    formData.append("file", values);
    formData.append("video_id", data?.id);
    const action = (val) => {
      setSelected((prev) => {
        if (!Array.isArray(prev)) return [{ file: values, id: val }];
        const next = [...prev];
        next[index] = { ...next[index], id: val };
        return next;
      });
    };

    await dispatch(addVideoFilesRequest(formData, action));
  };

  useEffect(() => {
    const files = data?.files;
    if (Array.isArray(files) && files.length > 0) {
      setFieldsCount(files.length);
      setSelected(
        files.map((val, idx) => ({
          id: val?.id,
          name: `file_${idx + 1}`,
          file: val.file,
        }))
      );
    } else {
      setFieldsCount(1);
      setSelected([{ name: "upload file", file: "" }]);
    }
  }, [data, isAdd]);

  const displayName = (index) => {
    const row = Array.isArray(selected) ? selected[index] : undefined;
    if (row?.name && row.name !== "upload file") return row.name;
    return "Choose file to upload";
  };

  return (
    <MainModel
      header={header}
      closeFunc={closeFunc}
      openVar={openVideo}
      buttonTitle={null}
      buttonFunc={handelFiles}
      isLoading={isLoading}
      size="2xl"
      contentProps={adminModalContentProps}
      headerProps={adminModalHeaderProps}
      bodyProps={adminModalBodyProps}
    >
      <VStack spacing={4} align="stretch" w="100%">
        {[...Array(fieldsCount)].map((_, index) => (
          <Flex
            key={index}
            gap={3}
            align="center"
            flexWrap="wrap"
            py={1}
            w="100%"
          >
            <Button {...filePickButtonSx}>
              <Text px={2} noOfLines={1} w="100%">
                {displayName(index)}
              </Text>
              <Input
                type="file"
                opacity="0"
                position="absolute"
                cursor="pointer"
                top={0}
                left={0}
                w="100%"
                h="100%"
                aria-label="Choose file"
                onChange={(e) => {
                  const file = e?.target?.files?.[0];
                  setSelected((prev) => {
                    const base = Array.isArray(prev) ? [...prev] : [];
                    base[index] = {
                      ...base[index],
                      file,
                      name: file?.name ?? "upload file",
                    };
                    return base;
                  });
                }}
              />
            </Button>

            <Button
              {...uploadButtonProps}
              isLoading={isLoading}
              isDisabled={!selected?.[index]?.file}
              onClick={() => handelFiles(selected?.[index]?.file, index)}
            >
              Upload
            </Button>

            <HStack spacing={2} ml={{ base: 0, md: "auto" }}>
              <IconButton
                {...iconOutlineProps}
                aria-label="Add another file row"
                icon={<RiAddCircleLine size={18} />}
                onClick={() => {
                  setSelected((s) => [
                    ...(Array.isArray(s) ? s : []),
                    { name: "upload file", file: "" },
                  ]);
                  setFieldsCount((c) => (Number.isFinite(c) ? c : 0) + 1);
                }}
              />
              <IconButton
                {...iconOutlineProps}
                aria-label="Remove this row"
                icon={<RiIndeterminateCircleLine size={20} />}
                onClick={() => {
                  const prev = Array.isArray(selected) ? selected : [];
                  const newData = prev.filter((_, idx) => idx !== index);
                  const next =
                    newData.length > 0
                      ? newData
                      : [{ name: "upload file", file: "" }];
                  setSelected(next);
                  setFieldsCount(next.length);
                }}
              />
              {selected?.length >= index + 1 && selected?.[index]?.id ? (
                <IconButton
                  {...iconOutlineProps}
                  aria-label="Delete uploaded file"
                  icon={<RiDeleteBin6Line size={18} />}
                  borderColor="rgba(229, 62, 62, 0.45)"
                  color="#C53030"
                  _hover={{
                    bg: "rgba(254, 215, 215, 0.35)",
                    borderColor: "#C53030",
                    color: "#9B2C2C",
                  }}
                  onClick={() => {
                    dispatch(deleteVideoFilesRequest(selected?.[index]?.id));
                    const prev = Array.isArray(selected) ? selected : [];
                    const newData = prev.filter((_, idx) => idx !== index);
                    const next =
                      newData.length > 0
                        ? newData
                        : [{ name: "upload file", file: "" }];
                    setSelected(next);
                    setFieldsCount(next.length);
                  }}
                />
              ) : null}
            </HStack>
          </Flex>
        ))}
      </VStack>
    </MainModel>
  );
};

export default AddVideoFiels;
